// extracted by mini-css-extract-plugin
module.exports = {"custom-header":"headerSkydropx_custom-header__1JHtv"};